import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource/anton/400.css";
import "@fontsource-variable/archivo/wght.css";
import "@fontsource/ibm-plex-mono/400.css";
import "@fontsource/ibm-plex-mono/500.css";
import "maplibre-gl/dist/maplibre-gl.css";
import "./styles.css";
import App from "./App";

const container = document.getElementById("root");
if (!container) throw new Error("Falta el contenedor #root en index.html");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
